import { Input } from "@/components/ui/input";

interface WeightFieldProps {
  weight: string;
  onWeightChange: (value: string) => void;
}

export const WeightField = ({ weight, onWeightChange }: WeightFieldProps) => (
  <div className="flex items-center justify-between gap-4 rounded-lg border border-border/70 px-3 py-3">
    <div>
      <div className="text-sm font-medium text-foreground">Weight</div>
      <div className="text-xs text-muted-foreground">
        How much this evaluator counts toward the overall score. Default is 1 — set to 2 to count it
        twice as much as a standard evaluator when averaging.
      </div>
    </div>
    <Input
      value={weight}
      onChange={event => onWeightChange(event.target.value)}
      className="w-20 shrink-0 text-center"
      inputMode="decimal"
      placeholder="1"
    />
  </div>
);
